export default __webpack_public_path__ + "static/media/marketing.976178f9.mp4";